module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-right-down-66027d7e12f960af649096c98611d378.svg";